import React from 'react'
import Button from 'material-ui/Button'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog'
import { connect } from 'react-redux'
import * as dialogActions from 'actions/dialog'
import Slide from 'material-ui/transitions/Slide'
import compose from 'recompose/compose'

const ResponsiveDialog = withMobileDialog({ breakpoint: 'sm' })(Dialog)

const AlertDialog = ({ open, params, handleRequestClose, performAction }) => (
  <ResponsiveDialog
    fullScreen={params.fullscreen}
    open={open}
    transition={Slide}
    onRequestClose={handleRequestClose}
  >
    <DialogTitle>{params.title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{params.body}</DialogContentText>
      {params.form}
    </DialogContent>
    <DialogActions>
      <Button onClick={handleRequestClose} color="primary">
        Cancel
      </Button>
      <Button onClick={performAction} color="primary">
        Ok
      </Button>
    </DialogActions>
  </ResponsiveDialog>
)

const mapStateToProps = state => ({
  open: state.dialog.isOpen,
  params: state.dialog.params,
})

const mapDispatchToProps = dispatch => ({
  handleRequestClose: () => dispatch(dialogActions.closeDialog()),
  performAction: () => dispatch(dialogActions.performAction()),
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AlertDialog
)



// WEBPACK FOOTER //
// ./src/components/Dialog.js